<div class="rp-card" *ngIf="model?.fidelidadPointsTotal">

  <!-- Columna izquierda: nivel y puntos -->
  <div class="rp-nivel">
    <!-- General es el nivel base: no encaja con "Sos X de las mascotas", asi
         que lleva frase propia. -->
    <div class="rp-nivel-texto" *ngIf="nivelActual === 'General'">
      Nivel <strong>General</strong>
    </div>
    <div class="rp-nivel-texto" *ngIf="nivelActual !== 'General'">
      Sos <strong>{{ nivelActual }}</strong><br>de las mascotas
    </div>
    <div class="rp-puntos">{{ puntosTotales | number:'1.0-0':'es-AR' }}</div>
    <div class="rp-puntos-label">puntos</div>
  </div>

  <!-- Columna derecha -->
  <div class="rp-progreso">

    <div class="rp-falta" *ngIf="!estaEnNivelMasAlto && nivelSiguiente">
      Te faltan <strong>{{ puntosFaltantes | number:'1.0-0':'es-AR' }} puntos</strong>
      para ser {{ nivelSiguiente }}
    </div>
    <div class="rp-falta" *ngIf="estaEnNivelMasAlto">
      ¡Estás en el nivel más alto!
    </div>

    <div class="rp-barra">
      <div class="rp-barra-relleno" [style.width.%]="porcentajeAvance"></div>
    </div>

    <div class="rp-barra-labels" *ngIf="nivelSiguiente">
      <span>{{ nivelActual }}, {{ umbralActual | number:'1.0-0':'es-AR' }}</span>
      <span>{{ nivelSiguiente }}, {{ umbralSiguiente | number:'1.0-0':'es-AR' }}</span>
    </div>

    <!-- Incentivo al nivel siguiente. El ahorro es una ESTIMACION: se anualiza
         la venta con las compras disponibles. Ver resumen-puntos.component.ts. -->
    <div class="rp-incentivo" *ngIf="nivelSiguiente">
      <span>
        <strong>Siendo {{ nivelSiguiente }}:</strong>
        más descuento en tus compras<ng-container *ngIf="ahorroAnualEstimado">,
          que pueden representar un ahorro anual de
          {{ ahorroAnualEstimado | currency:'ARS':'symbol-narrow':'1.0-0':'es-AR' }}</ng-container>
      </span>
      <a class="rp-vertodo" [routerLink]="['/mis-beneficios']">Ver todo ›</a>
    </div>

    <!-- Puntos por vencer este mes: calculados desde el historial real. Solo
         aparece si hay algo por vencer. -->
    <div class="rp-mini" *ngIf="hayPorVencer">
      <div class="rp-mini-item">
        <strong>{{ puntosPorVencer | number:'1.0-0':'es-AR' }} puntos</strong>
        vencen el {{ finDeMesActual | date:'d \'de\' MMMM':'':'es-AR' }}
      </div>
    </div>

  </div>
</div>
